<template>
    <div class="search-bar">
        <button class="button" @click="onFocus">
            Search
        </button>
        <transition name="search">
            <form v-if="focussed" action="/search" method="get" class="form">
                <svg-magnifier />
                <input type="hidden" name="type" value="product" />
                <input
                    :value="value"
                    class="search"
                    type="text"
                    ref="field"
                    name="q"
                />
            </form>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            focussed: false,
            value: ''
        }
    },
    methods: {
        async onFocus() {
            this.focussed = true
            await this.$nextTick()
            this.$refs.field.focus()

            // one-time listener to unfocus
            const onClick = e => {
                if (this.$el.contains(e.target)) return
                this.focussed = false
                window.removeEventListener('click', onClick)
            }
            window.addEventListener('click', onClick)
        }
    }
}
</script>

<style lang="scss">
@import 'src/scss/variables';

.search-bar {
    font-family: $walsh;
    position: relative;

    button {
        -webkit-appearance: none;
        background: none;
        border: none;
        padding: 0;
        margin: 0;
    }
    .form {
        position: absolute;
        width: 200px;
        bottom: 0;
        right: 0;
    }
    .search {
        box-sizing: border-box;
        font-family: $walsh;
        font-size: 18px;
        border: none;
        width: 100%;
        padding: 0;
        border-bottom: 2px solid $red;
        padding-left: 18px;
    }
    .svg-magnifier {
        position: absolute;
        top: 3px;
        left: 0;
    }

    // transition
    .search-enter-active {
        transition: opacity 200ms, width 450ms ease;
    }
    .search-leave-active {
        animation: searchslide 450ms linear;
    }
    .search-enter {
        width: 100px;
        opacity: 0;
    }
}

@keyframes searchslide {
    0% {
        width: 200px;
        opacity: 1;
    }
    40% {
        width: 140px;
        opacity: 1;
    }
    50% {
        width: 130px;
        opacity: 1;
    }
    100% {
        width: 100px;
        opacity: 0;
    }
}
</style>
